import * as types from '../constants/signup';
import { mapErrorMessage } from '../../Utils/mapErrorMessage';
import { toast } from 'react-toastify';
import parseDjangoError from 'Utils/parseDjangoError';

const RESEND_INITIAL_STATE = { isLoading: false, sent: false, error: null };

const INITIAL_STATE = {
  isLoading: false,
  success: false,
  error: null,
  data: null,
  // Email confirmation: `confirmationError.code` drives which branch the page renders.
  confirmed: false,
  confirmationError: null,
  resend: RESEND_INITIAL_STATE,
  setPassword: { isLoading: false, sent: false, error: null },
};

export default function signupApiReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // SIGNUP
    case types.API_SIGNUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };

    case types.API_SIGNUP_REQUEST_SUCCESS:
      toast.success('Signed up successfully');
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        data: action.response.data,
      };

    case types.API_SIGNUP_REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: mapErrorMessage(action),
      };

    case types.API_CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
      };

    case types.API_CHANGE_PASSWORD_SUCCESS:
      toast.success('Password changes successfully');
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        data: action.response.data,
      };

    case types.API_CHANGE_PASSWORD_FAILED:
      toast.error(parseDjangoError(action.response.response.data.message));
      return {
        ...state,
        isLoading: false,
        success: false,
        error: mapErrorMessage(action),
      };

    case types.API_USER_CONFIRMATION_REQUEST:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
        confirmed: false,
        confirmationError: null,
      };

    case types.API_USER_CONFIRMATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        confirmed: true,
        data: action.response.data,
      };

    case types.API_USER_CONFIRMATION_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        confirmationError: {
          code: action.payload?.code || null,
          detail: action.payload?.detail || 'Could not verify this link.',
        },
      };

    case types.API_RESEND_CONFIRMATION_REQUEST:
      return {
        ...state,
        resend: { isLoading: true, sent: false, error: null },
      };

    case types.API_RESEND_CONFIRMATION_SUCCESS:
      return {
        ...state,
        resend: { isLoading: false, sent: true, error: null },
      };

    case types.API_RESEND_CONFIRMATION_FAILED:
      return {
        ...state,
        resend: {
          isLoading: false,
          sent: false,
          error: {
            code: action.payload?.code || null,
            detail: action.payload?.detail || 'Could not send the link.',
          },
        },
      };

    case types.RESET_RESEND_CONFIRMATION:
      return { ...state, resend: RESEND_INITIAL_STATE };

    case types.API_SET_PASSWORD_REQUEST:
      return {
        ...state,
        setPassword: { isLoading: true, sent: false, error: null },
      };

    case types.API_SET_PASSWORD_SUCCESS:
      return {
        ...state,
        setPassword: { isLoading: false, sent: true, error: null },
      };

    case types.API_SET_PASSWORD_FAILED:
      return {
        ...state,
        setPassword: {
          isLoading: false,
          sent: false,
          error: action.payload?.detail,
        },
      };

    case types.SET_SUCCESS:
      return {
        ...state,
        success: action.payload,
        data: null,
      };

    default:
      return state;
  }
}
